import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const NotFound = () => {
  const location = useLocation();
  useEffect(() => {
    console.error("404:", location.pathname);
  }, [location.pathname]);
  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "#F8F4EC", color: "#1a1a1a", fontFamily: "Barlow, sans-serif" }}>
      <Helmet>
        <title>404 — Page not found | HireEva</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <div style={{ textAlign: "center", padding: 24 }}>
        <h1 style={{ fontFamily: "'Instrument Serif', serif", fontStyle: "italic", fontSize: "clamp(80px, 12vw, 160px)", lineHeight: 1, margin: 0 }}>404</h1>
        <p style={{ marginTop: 16, color: "#6b6357" }}>This page wandered off.</p>
        <Link to="/" style={{ display: "inline-block", marginTop: 24, padding: "12px 22px", background: "#1a1a1a", color: "#fff", borderRadius: 999, textDecoration: "none", fontSize: 14 }}>← Back home</Link>
      </div>
    </div>
  );
};
export default NotFound;
